import { Popover } from '@heathmont/moon-core-tw';
import sendEventToUmami from '~/shared/trackEvent/sendEventToUmami';
import getSortOptions from './helpers/getSortOptions';
import SortItem from './SortItem';
import useSortFilter from './useSortFilter';
import IconButton from '../IconButton';

type Props = { isLiveRtp?: boolean };

const SortFilter: FC<Props> = ({ isLiveRtp }) => {
  const { selected, label, sortByLabel, handleSelect, isFullWidth } =
    useSortFilter();
  return (
    <div className="grid grid-cols-[minmax(1px,_1fr)] items-end gap-1 [grid-area:sort]">
      <p className="text-moon-14 text-trunks">{sortByLabel}</p>
      <Popover position="bottom-end">
        <Popover.Trigger>
          <IconButton fullWidth={isFullWidth}>{label}</IconButton>
        </Popover.Trigger>
        <Popover.Panel className="w-60 p-3">
          {getSortOptions(isLiveRtp).map((item) => (
            <SortItem
              key={item}
              current={selected}
              item={item}
              handleSortSelect={() => {
                sendEventToUmami(
                  {
                    'sort-base': item,
                  },
                  isLiveRtp ? 'changeRtpSortBy' : 'changeSortBy',
                );

                handleSelect(item);
              }}
            />
          ))}
        </Popover.Panel>
      </Popover>
    </div>
  );
};

export default SortFilter;
